export const routes = [
  {
    path: '/gestione/v-cg-ingresso',
    name: 'FlussiIngresso',
    component: () => import(/* webpackChunkName: "gestione_flussi_ingresso" */ '../views/controlloGestione/flussiIngresso')
  },
  {
    path: '/gestione/v-cg-uscita',
    name: 'FlussiUscita',
    component: () => import(/* webpackChunkName: "gestione_flussi_uscita" */ '../views/controlloGestione/flussiUscita')
  },
  {
    path: '/gestione/v-cg-situazione',
    name: 'Situazione',
    component: () => import(/* webpackChunkName: "gestione_situazione" */ '../views/controlloGestione/situazione')
  },
  {
    path: '/gestione/v-cg-analisi',
    name: 'Analisi',
    component: () => import(/* webpackChunkName: "gestione_analisi" */ '../views/controlloGestione/analisi')
  },
  {
    path: '/gestione/v-cg-personale',
    name: 'Personale',
    component: () => import(/* webpackChunkName: "gestione_personale" */ '../views/controlloGestione/personale')
  }  
]